// extracted by mini-css-extract-plugin
export var infoRow = "_ut-2";
export var labelContainer = "_ut-0";
export var rightInfo = "_ut-1";